import { getEnvVariable } from '~/dev/utils/getEnvVariable';

import Configuration from './configuration';
import createService from './createService';
import { JsonApiError } from './errors/JsonApiError';

const clausewitzEndpoint = getEnvVariable('REACT_APP_CLAUSEWITZ_ENDPOINT');

export const clausewitz = createService({
  shouldRetryOn401: true,
  url: `${clausewitzEndpoint}/api/v1`,
});

export const pilot = createService({
  shouldRetryOn401: true,
  url: `${Configuration.pilotEndpoint}/api/v2`,
});

export const pilotV3 = createService({
  shouldRetryOn401: true,
  url: `${Configuration.pilotEndpoint}/api/v3`,
});

// Same API as `pilotV3`, but a 401 is not allowed to force a logout. For
// requests the app fires on its own — a prefetch, a startup warm-up — a 401
// can mean "not authorized for this specific check" as easily as "your
// session is dead," and nobody asked for this call in a way that justifies
// tearing down a session that may still be perfectly valid. Reach for this
// only for that kind of background call; anything a person's action depends
// on should still go through `pilotV3` and get the real reauth flow.
export const pilotV3Background = createService({
  shouldRetryOn401: false,
  url: `${Configuration.pilotEndpoint}/api/v3`,
});

export const publicApi = createService({
  shouldRetryOn401: true,
  url: `${Configuration.publicApiEndpoint}/v1`,
});

export const everest = createService({
  shouldRetryOn401: true,
  url: `${Configuration.everestEndpoint}/`,
});

export const auth = createService({
  url: `${Configuration.authEndpoint}/v1`,
  refresh_token: true,
});

export const authExt = createService({
  shouldRetryOn401: true,
  url: `${Configuration.authEndpoint}/ext`,
});

export const aegis = createService({
  shouldRetryOn401: true,
  url: `${Configuration.authEndpoint}/v1`,
});

export const weaver = createService({
  shouldRetryOn401: true,
  url: `${Configuration.weaverEndpoint}/`,
});

export const genAi = createService({
  shouldRetryOn401: true,
  url: `${Configuration.genAiEndpoint}/`,
});

export const muse = createService({
  shouldRetryOn401: true,
  url: `${Configuration.museEndpoint}/`,
});

export const sylvanus = createService({
  shouldRetryOn401: true,
  url: `${Configuration.sylvanusEndpoint}/api/v1`,
});

export const eviSearch = createService({
  shouldRetryOn401: true,
  url: `${Configuration.evisearchEndpoint}/`,
});

export const wopi = createService({
  shouldRetryOn401: true,
  url: Configuration.wopiEndpoint,
});

export const codeCash = createService({
  shouldRetryOn401: true,
  url: `${Configuration.codeCash}/api/v1`,
});

export const earlyAccess = createService({
  shouldRetryOn401: true,
  url: `${Configuration.earlyAccessEndpoint}/v1`,
});

export const atlas = createService({
  shouldRetryOn401: true,
  url: `${Configuration.atlas}/api/v1`,
  errorHandler: (error) => {
    throw new JsonApiError(error.response?.data?.errors);
  },
});

export const rolodex = createService({
  shouldRetryOn401: true,
  url: `${Configuration.rolodexEndpoint}/api/v1`,
});

export const courier = createService({
  shouldRetryOn401: true,
  url: `${Configuration.courier}/api/v1`,
});

export const managedEntities = createService({
  shouldRetryOn401: true,
  url: `${Configuration.managedEntities}/api/v1`,
});

export const evi2ken = createService({
  shouldRetryOn401: true,
  url: `${Configuration.evi2ken}/v1`,
});

export const scribyl = createService({
  shouldRetryOn401: true,
  url: `${Configuration.scribyl}/api/v1`,
});

export const esignature = createService({
  shouldRetryOn401: true,
  url: `${Configuration.esignatureEndpoint}/api/v1`,
});

export const k2 = createService({
  shouldRetryOn401: true,
  url: `${Configuration.k2Endpoint}/api/v1`,
});

export const unifiedFields = createService({
  shouldRetryOn401: true,
  url: `${Configuration.unifiedFieldsEndpoint}/api/v1`,
});

export const hermes = createService({
  shouldRetryOn401: true,
  url: `${Configuration.hermesEndpoint}/v1`,
});
